import useViewsSelector from "views/stores/useViewsSelector";
import { selectCurrentQuery } from "views/logic/slices/viewSelectors";
const useCurrentQuery = () => useViewsSelector(selectCurrentQuery);
export default useCurrentQuery;
